import AudioDebugPanel from './AudioDebugPanel';
import { FlagDebugPanel } from './FlagDebugPanel';
import { LocationDebugPanel } from './LocationDebugPanel';

interface Component {
  onError?: ((error: string) => void) | undefined;
  onClose: () => void;
}

interface DebugPanel {
  id: string;
  label: string;
  component: (props: Component) => JSX.Element;
}

const panels: DebugPanel[] = [
  {
    id: 'audio-debug',
    label: 'Realtime Audio',
    component: ({ onError, onClose }) => (
      <AudioDebugPanel onError={onError} onClose={onClose} />
    ),
  },
  {
    id: 'location-debug',
    label: 'Plot Location',
    component: ({ onClose }) => <LocationDebugPanel onClose={onClose} />,
  },
  {
    id: 'flag-debug',
    label: 'Feature Flags',
    component: ({ onClose }) => <FlagDebugPanel onClose={onClose} />,
  },
];

export default panels;
